// src/components/auth/AdminProtectedRoute.tsx - Updated
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface AdminProtectedRouteProps {
  children: React.ReactElement;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin role
  if (!user || user.userType !== 'admin') {
    // Redirect non-admin users to their appropriate home page
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default AdminProtectedRoute;